import { createFileRoute } from "@tanstack/react-router";
import { EmailChangePage } from "../../features/auth/EmailChangePage";
import { linkTokenOf } from "../../search";

export const Route = createFileRoute("/auth/email-change")({
  validateSearch: (search: Record<string, unknown>) => linkTokenOf(search, "email_change"),
  component: function EmailChange() {
    return <EmailChangePage tokenHash={Route.useSearch().token_hash} />;
  },
});
